import React, { Component } from 'react'
import '../udi/outStockConfig.less'
import "@/static/style/margin.less"
import "@/static/style/init.less"
import "@/static/style/common.less"
import { Button, Table, message, Modal, Input, Select, Tooltip, Pagination, Checkbox, Spin } from 'antd'
import _, { get, filter } from 'lodash'
import { ajaxApi } from '@/server/index'
import common from "@/public/common";
import { getCookie, getParmUrl } from '@/public/utils'
import { set } from '@antv/util'
import { EditOutlined } from '@ant-design/icons';
var { Option } = Select

var apiHost = common.SapUrl
class productCatalogDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            params: {
                "s_code": getCookie('supplier_code')||'',
                "item_code": "",
                "sigo_name": "",
                "supplier_product_code": "",
                "page_index": 1,
                "page_size": 10,
            },
            columns: [
                {
                    title: '视客货品编码',
                    key: "product_code",
                    dataIndex: "product_code",
                    align: 'center',
                },
                {
                    title: "视客货品名称",
                    key: "product_name",
                    dataIndex: "product_name",
                    align: 'center',
                },
                {
                    title: "供应商货品编码",
                    key: "supplier_product_code",
                    dataIndex: "supplier_product_code",
                    align: 'center',
                    render: (text, record) => {

                        return (
                            <span>
                                {/* {
                                    get(record, 'edit') ?
                                        <span>
                                            <Input
                                                // key={get(record, 'supplier_product_code')}
                                                placeholder="请输入"
                                                className='width_150_input'
                                                onChange={this.iptChangeTable.bind(this, record)}
                                                name='supplier_product_code'
                                                value={text}
                                                onBlur={this.updateCode.bind(this, record)}
                                            />
                                            <a className='ml10'
                                                onClick={this.updateCode.bind(this, record)}
                                            ><CheckOutlined /><span className='ml4'>提交</span></a>
                                        </span>
                                        : <span>
                                            {text}
                                            <a className='ml6' onClick>更多</a>
                                            <a className='ml10' onClick={this.changeEdit.bind(this, record)} ><EditOutlined /></a>
                                        </span>
                                } */}
                                {this.getShow2AndMore(get(record, 'supplier_product_codes'))}
                                <a className='ml10' onClick={this.changeEditModal.bind(this, record)} ><EditOutlined /></a>
                            </span>
                        )
                    }
                },
            ],
            columnsModal: [
                {
                    title: '序号',
                    key: "index",
                    dataIndex: "index",
                    align: 'center',
                    render:(text)=>{
                        return <span>{text+1}</span>
                    }
                },
                {
                    title: '供应商货品编码',
                    key: "supplier_product_code",
                    dataIndex: "supplier_product_code",
                    align: 'center',
                    width:300,
                    render: (text, record) => {
                        return (
                            <Input
                                placeholder="请输入"
                                className='width_250_input'
                                onChange={this.iptChangeTable.bind(this, record)}
                                name='supplier_product_code'
                                value={text}
                            />
                        )
                    }
                },
                {
                    title: '操作',
                    key: "id",
                    dataIndex: "id",
                    align: 'center',
                    width:80,
                    render: (text, record) => {
                        return (
                            <a onClick={this.deleteRow.bind(this,text)}>删除</a>
                        )
                    }
                },
            ]
        };
    }

    deleteRow=(text)=>{
        let { modalParams } = this.state
        var supplier_product_codes = _.reject(get(modalParams, 'supplier_product_codes'),['id',text])
        set(modalParams, 'supplier_product_codes', this.resetIndex(supplier_product_codes))
        this.setState({
            modalParams,
        })
    }

    resetIndex=(supplier_product_codes)=>{
        return supplier_product_codes.map((item,index)=>{
            return {
                ...item,index,id:index
            }
        })
    }

    getShow2AndMore = (list) => {
        var before = _.slice(list, 0, 2)
        var after = _.slice(list, 2)
        return (
            <span>
                {
                    get(before, 'length') &&
                    before.map((item, index) => {
                        return item + (index + 1 < get(before, 'length') ? ',' : '')
                    })
                }
                {
                    get(list, 'length') > 2 &&
                    <Tooltip title={
                        get(after, 'length') &&
                        after.map((item, index) => {
                            return item + (index + 1 < get(after, 'length') ? ',' : '')
                        })
                    }>
                        <a className='ml4'>更多</a>
                    </Tooltip>
                }
            </span>
        )
    }

    changeEditModal = (record) => {
        var modalParams = _.cloneDeep(record)
        modalParams.supplier_product_codes = (get(modalParams, 'supplier_product_codes')).map((item, index) => {
            return { index: index, supplier_product_code: item }
        })
        this.setState({
            bindVisible: true,
            modalParams
        })
    }

    iptChangeTable = (record, e) => {
        let { modalParams } = this.state
        var supplier_product_codes = _.cloneDeep(get(modalParams, 'supplier_product_codes'))
        supplier_product_codes.map(item => {
            if (item.index == get(record, 'index')) {
                set(item, 'supplier_product_code', e.target.value)
            }
        })
        set(modalParams, 'supplier_product_codes', supplier_product_codes)
        this.setState({
            modalParams
        })
    }


    updateCode = async (record) => {
        this.changeLoading(true)
        try {
            let params = {
                "s_code": getCookie('supplier_code')||'',
                "admin_id": this.getModerId(),
                "supplier_product_code": get(record, 'supplier_product_code'),
                "product_code": get(record, 'product_code'),
            }
            const res = await ajaxApi({
                url: `${apiHost}supplier-item/update-supplier-product-code`,
                params,
            });
            set(record, 'edit', false)
            message.success('提交成功！')
            this.reloadSearchModal()
        } catch (err) {
            this.changeLoading(false)
        }
    }

    changeEdit = (record) => {
        let { data } = this.state
        let index = _.findIndex(data, { 'product_code': record.product_code })
        set(data, `${index}.edit`, true)
        this.setState({ data })
    }

    componentDidMount() {
        this.init()
    }

    init = () => {
        let { params } = this.state
        set(params, 'item_code', getParmUrl('item_code'))
        this.setState({
            lookVisible: true,
            params
        })
        _.defer(this.search, 1000)
    }

    search = async () => {
        let { params } = this.state
        set(params, 'page_index', 1)
        this.setState({ params })
        _.defer(this.getTableData, 1000)
    }

    getTableData = async () => {
        this.changeLoading(true)
        try {
            let { params } = this.state
            const res = await ajaxApi({
                url: `${apiHost}supplier-item/query-product-list`,
                params: params,
            });
            set(params, 'total', get(res, 'data.data.total_size', 0))
            this.setState({
                data: get(res, 'data.data.data', []),
                params
            })
            this.changeLoading(false)
        } catch (err) {
            this.changeLoading(false)
        }
    }

    iptChangeModal = (e) => {
        let { params } = this.state
        set(params, e.target.name, e.target.value.trim())
        this.setState({
            params
        })
    }

    reloadSearch = () => {
        let { params } = this.state
        this.setState({
            params: {
                "sigo_name": "",
                "supplier_product_code": "",
                "page_index": 1,
                "page_size": 10,
                "item_code": params.item_code
            }
        })
        _.defer(this.search, 1000)
    }


    onShowSizeChangeModal = (current, pageSize) => {
        try {
            let { params } = this.state
            set(params, 'page_size', pageSize)
            set(params, 'page_index', current)
            this.setState({
                params
            }, () => {
                this.getTableData();
            });
        } catch (error) {
            console.log(error);
        }
    };

    getSid = () => {
        return getCookie('supplierinfo') ? JSON.parse(getCookie('supplierinfo')).sid : null
    }

    getModerId = () => {
        var moder_id = getCookie('supplier_company_code') ||null
        return moder_id
    }

    changeLoading = (loading) => {
        this.setState({ loading })
    }

    add = () => {
        let { modalParams } = this.state
        var supplier_product_codes = _.cloneDeep(get(modalParams, 'supplier_product_codes'))
        supplier_product_codes.push({
            index: get(supplier_product_codes, 'length'),
            supplier_product_code: ''
        })
        set(modalParams, 'supplier_product_codes', supplier_product_codes)
        this.setState({
            modalParams
        })
    }

    bindFun = async () => {
        try {
            if (!this.bindFunCheck()) {
                return
            }
            let { modalParams } = this.state
            var params = {
                "s_code": getCookie('supplier_code')||'',
                "admin_id": this.getModerId(),
                "supplier_product_codes": get(modalParams, 'supplier_product_codes').map(item => { return item.supplier_product_code }),
                "product_code": get(modalParams, 'product_code')
            }
            const res = await ajaxApi({
                url: `${apiHost}supplier-item/update-supplier-product-code`,
                params: params,
            });
            message.success('货品编码绑定成功！')
            this.handleCancel()
            _.defer(this.search, 1000)
        } catch (err) {
            console.log(err)
        }
    }

    handleCancel = () => {
        this.setState({
            bindVisible: false,
            modalParams: {}
        })
    }

    bindFunCheck = () => {
        let { modalParams } = this.state
        var flag = true
        if (!get(modalParams, 'supplier_product_codes.length')) {
            message.error('请输入货品编码')
            flag = false
        }
        if (get(filter(get(modalParams, 'supplier_product_codes'), ['supplier_product_code', '']), 'length')) {
            message.error('货品编码不能为空')
            flag = false
        }
        return flag

    }

    checkChange = (e) => {
        let { params } = this.state
        set(params, 'is_bind', e.target.checked?1:0)
        this.setState({
            params
        }, () => {
            this.getTableData();
        });
    }

    render() {
        let { params, modalParams } = this.state
        return (
            <div className='purchaseAdjustList outStockConfig'>
                <section className="search mb20" >
                    <span className='ml12'>视客货品：</span>
                    <Input
                        placeholder="请输入编码或名称"
                        className='width_200_input'
                        onChange={this.iptChangeModal}
                        name='sigo_name'
                        value={get(params, 'sigo_name')}
                    />
                    <span className='ml12'>供应商货品：</span>
                    <Input
                        placeholder="请输入"
                        className='width_150_input mr16'
                        onChange={this.iptChangeModal}
                        name='supplier_product_code'
                        value={get(params, 'supplier_product_code')}
                    />
                    <Checkbox
                        checked={get(params, 'is_bind')}
                        onChange={this.checkChange}>只筛选待绑定的</Checkbox>
                    <div className='floatRight'>
                        <Button type="primary" className='ml16' onClick={this.search}>查询</Button>
                        <Button className='ml16' onClick={this.reloadSearch}>重置</Button>
                    </div>
                </section>
                <Spin spinning={this.state.loading} >
                    <div style={{ overflow: 'hidden', background: '#fff' }}>
                        <Table
                            columns={this.state.columns}
                            dataSource={this.state.data}
                            pagination={false}
                            rowKey={record=>get(record,'product_code')}
                        ></Table>
                        <div style={{ float: 'right' }} className='mt20 mb20'>
                            <Pagination
                                current={get(params, 'page_index')}
                                showQuickJumper
                                total={get(params, 'total')}
                                pageSize={get(params, 'page_size')}
                                showSizeChanger
                                showTotal={() => {
                                    return <span style={{ marginRight: '20px', float: 'left' }}>
                                        共{get(params, 'total')}条，每页{get(params, 'page_size')}条
                                    </span>
                                }}
                                onShowSizeChange={this.onShowSizeChangeModal}
                                onChange={this.onShowSizeChangeModal}
                            />
                        </div>
                    </div>
                </Spin>
                <Modal
                    title="绑定供应商货品编码"
                    visible={this.state.bindVisible}
                    width={800}
                    onCancel={this.handleCancel}
                    onOk={this.bindFun}
                >
                    <Button className='ml16 mb16' onClick={this.add} type='primary'>添加新编码</Button>
                    <Table
                        columns={this.state.columnsModal}
                        dataSource={get(modalParams, 'supplier_product_codes')}
                        pagination={false}
                        scroll={{ y: 400 }}
                    ></Table>
                </Modal>

            </div>
        );
    }
}

export default productCatalogDetail;



// WEBPACK FOOTER //
// ./src/pages/commoditymanagement/productCatalogDetail.js